import { InjectionToken } from '@angular/core';
import { ReplaySubject } from 'rxjs';

export const SERVICE_SERVER_API_KEY = new InjectionToken<ReplaySubject<string | null>>('service-server-api-key', {
  providedIn: 'root',
  factory: () => new ReplaySubject<string | null>(),
});

export const HIDE_CHANGELOG = new InjectionToken<boolean>('HIDE_CHANGELOG');
